// A page counts one thing it showed or a person did (walking round, the
// "since you were here" card shown or clicked): POST /api/beacon with the
// word alone. No cookie of its own, no id; the server keeps a daily total.

export type Beacon = 'walk' | 'since-shown' | 'since-click' | 'shop-view';

export function beacon(what: Beacon): void {
  try {
    if (navigator.sendBeacon) navigator.sendBeacon('/api/beacon', what);
    else fetch('/api/beacon', { method: 'POST', body: what, keepalive: true }).catch(() => {});
  } catch { /* counting never gets in the way */ }
}
